import { shadeColor } from '@codeleap/utils'
import { createStyles } from '@codeleap/styles'
import { LoadingOverlayComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'

const createLoadingOverlayVariant = createStyles<LoadingOverlayComposition>

export const LoadingOverlayStyles = {
  default: createLoadingOverlayVariant((theme) => ({
    wrapper: {
      backgroundColor: shadeColor(theme.baseColors.neutralSolid300, 0, 0.5),
      backdropFilter: 'blur(5px)',
      position: 'absolute',
      ...theme.presets.whole,
      zIndex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      opacity: 0,
      pointerEvents: 'none',
    },
    'wrapper:visible': {
      opacity: 1,
      pointerEvents: 'auto',
    },
  })),
}

StyleRegistry.registerVariants('LoadingOverlay', LoadingOverlayStyles)
